enum Paths {
    productCategory = '/products/categories',
    productCategoryCreate = '/products/categories/create',
}

export default Paths;



// WEBPACK FOOTER //
// ./src/modules/ProductCategory/paths.ts